import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_BASE_INPUT_TYPE = {
  Text: "text",
  Password: "password",
  Email: "email",
  Tel: "tel",
  URL: "url",
  Search: "search",
  Number: "number",
} as const;

export type DSBaseInputType = ObjectValues<typeof DS_BASE_INPUT_TYPE>;
